module.exports = __webpack_public_path__ + "static/media/opentrunk.4a4b782d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/opentrunk.png
// module id = 760
// module chunks = 0